import { render, staticRenderFns } from "./scrollBar.vue?vue&type=template&id=4477e7f3&scoped=true&"
import script from "./scrollBar.vue?vue&type=script&lang=ts&"
export * from "./scrollBar.vue?vue&type=script&lang=ts&"
import style0 from "./scrollBar.vue?vue&type=style&index=0&id=4477e7f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4477e7f3",
  null
  
)

component.options.__file = "scrollBar.vue"
export default component.exports